import api from 'api';
import FileSaver from 'file-saver';

export const RECIPE_EXCEL_DOWNLOAD_START = 'RECIPE_EXCEL_DOWNLOAD_START';
export const EXCEL_DOWNLOAD_RECIPE_CARD_SUCCESS = 'EXCEL_DOWNLOAD_RECIPE_CARD_SUCCESS';
export const RECIPE_EXCEL_DOWNLOAD_ERROR = 'RECIPE_EXCEL_DOWNLOAD_ERROR';

function excelDownloadStart() {
    return {
        type: RECIPE_EXCEL_DOWNLOAD_START,
    };
}

function excelDownloadRecipeSuccess(data, fileName) {
    return {
        type: EXCEL_DOWNLOAD_RECIPE_CARD_SUCCESS,
        payload: { data, fileName, }
    };
}

function excelDownloadError() {
    return {
      type: RECIPE_EXCEL_DOWNLOAD_ERROR,
    };
  }

export function getRecipeCardExcelAsync(recipeIds, fileName, isMultiple, isBatchRecipe) {
    return (dispatch, getState) => {
        dispatch(excelDownloadStart());
        return api.request('recipe/export', 'get', null, null, api.responseTypes.stream, {recipeIds, isMultiple, isBatchRecipe})
            .then((data) => {
                const output = new File([data], `${fileName}.xlsx`, { type: 'application/ms-excel' });
                FileSaver.saveAs(output);
                dispatch(excelDownloadRecipeSuccess(data, fileName));
                return data;
            })
            .catch((err) => {
                dispatch(excelDownloadError());
                throw (err);
            });
    };
}